<template>
    <Teleport to="body">
      <!-- Modal -->
      <Transition name="modal">
        <div v-if="options.showFreetour" class="modal-mask">
          <div class="modal-container row">
            <div class="col modal-header">
              <div class="row w-100">
                <div class="d-flex justify-content-end pt-2">
                  <button type="button" class="btn-close btn-desktop" @click="$emit('showModalFreetour', {data: {show: false, img: ''}})"
                    aria-label="Close"></button>
                </div>
              </div>
            </div>
            <div class="col modal-body">
              <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <img :src="options.imgFreetour" alt="Freetour" width="1280" height="1920">                    
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>
  </template>
    
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'ModalFreetour',
    props: ['options'],
    emits: ['showModalFreetour']
})
</script>
    
<style scoped lang="css">
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
    overflow-y: auto;
  }
  
  .modal-container {
    max-width: 1460px;
    width: 100%;
    margin: auto;
    padding: 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  
  
  .modal-header {
    height: 20px;
  }
  
  .modal-body img {
    max-width: 100%;
    object-fit: fill;
    height: auto;
  }
  
  .modal-default-button {
    float: right;
  }
  
  /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */
  
  .modal-enter-from {
    opacity: 0;
  }
  
  .modal-leave-to {
    opacity: 0;
  }
  
  .modal-body {
    margin: 10px 0;
  }
  
  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  
  .btn-close {
    opacity: 1;
  }
  
  .btn-desktop {
    display: block;
  }
  
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {

    .modal-container {
        width: 90%;
    }    
    .btn-desktop {
      margin-top: 5px;
      font-size: 25px;
      right: -15px;
    }
    
    .modal-header {
      height: 30px;
    }
  
  }
</style>
    